<template>
  <div 
    class="instant-service-card" 
    :class="{ 
      'is-disabled': disabled, 
      'is-requested': isRequested,
      'is-pending': isPending
    }"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <div class="card-glass-content">
      <div class="card-toggle" v-if="showToggle">
        <label class="switch" v-if="user_role === 'ClientAdmin'">
          <input
            type="checkbox"
            :checked="isActive || isRequested"
            @change="handleToggle"
          />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="pending-indicator" v-if="isRequested || isPending">
        <i class="fas fa-clock"></i>
      </div>

      <div class="card-icon-section">
        <div class="icon-wrapper">
          <div v-if="!disabled" class="play-button-wrapper" :class="{ 'show': hovering }">
            <button class="play-button" @click="$emit('utilize', service)">
              <i class="fas fa-play"></i>
            </button>
          </div>
          
          <i v-else class="card-icon fas fa-lock"></i>
        </div>
      </div>

      <div class="card-content-section card-bg">
        <div class="text-center">
          <p class="service-heading" :class="{ 'long-text': serviceName.length > 25 }">{{ serviceName }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InstantServiceCard",
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    category: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "This service provides comprehensive verification and validation capabilities.",
    },
  },
  data() {
    return {
      hovering: false,
      isRequested: false,
      user_role: ""
    };
  },
  mounted() {
    this.user_role = this.$store.getters.get_user_role;
  },
  computed: {
    isPending() {
      return this.category === 'Pending';
    },
    isDeclined() {
      return this.category === 'Declined';
    },
    isActive() {
      return this.category === 'Active';
    },
    isInactive() {
      return this.category === 'Inactive';
    },
    showToggle() {
      return this.isDeclined || this.isActive || this.isInactive;
    }
  },
  methods: {
    handleToggle(event) {
      this.isRequested = event.target.checked;
      this.$emit('request', { service: this.service, requested: this.isRequested });
    },
  },
  emits: ["utilize", "details", "request"],
};
</script>

<style scoped>
.instant-service-card {
  position: relative;
  width: 100%;
  height: 225px;
  border-radius: 24px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
  background: rgba(248, 249, 250, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 117, 125, 0.15);
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.03),
    0 6px 12px rgba(0, 0, 0, 0.04);
}

.instant-service-card:hover {
  box-shadow:
    0 6px 12px rgba(0, 0, 0, 0.05),
    0 10px 16px rgba(0, 0, 0, 0.06);
  border-color: rgba(108, 117, 125, 0.25);
  transform: translateY(-2px);
}

 .instant-service-card.is-disabled {
  cursor: default;
}

.instant-service-card.is-disabled:hover {
  transform: translateY(-1px);
}

.instant-service-card.is-requested {
  border: 1px solid rgba(255, 193, 7, 0.6);
  box-shadow:
    0 4px 8px rgba(255, 193, 7, 0.1),
    0 8px 16px rgba(255, 193, 7, 0.08);
}

.instant-service-card.is-pending {
  border: 1px solid rgba(13, 202, 240, 0.5);
}

.instant-service-card.is-pending:hover {
  border-color: rgba(13, 202, 240, 0.7);
}

.card-glass-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
}

.card-toggle {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--primary-color);
}

input:checked + .slider:before {
  transform: translateX(16px);
}

.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}

.pending-indicator {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 28px;
  height: 28px;
  background: rgba(13, 202, 240, 0.15);
  border: 1px solid #0dcaf0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  animation: pulse 2s infinite;
}

.pending-indicator i {
  color: #0dcaf0;
  font-size: 1.0rem;
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(13, 202, 240, 0.7);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(13, 202, 240, 0);
  }
}

.card-icon-section {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  background: rgba(200, 200, 200, 0.15);
  border-radius: 14px;
  padding: 16px;
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  position: relative;
}

.instant-service-card:hover .icon-wrapper {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.card-icon {
  font-size: 1.8rem;
  color: rgba(108, 117, 125, 0.7);
}

.play-button-wrapper {
  opacity: 0.5;
  transition: all 0.3s ease;
}

.play-button-wrapper.show {
  opacity: 1;
}

.play-button {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: var(--primary-color);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(var(--primary-color-rgb, 89, 255, 116), 0.4);
  transition: all 0.2s ease;
}

.play-button:hover {
  transform: scale(1.1);
  background: var(--primary-color);
  box-shadow: 0 5px 14px rgba(var(--primary-color-rgb, 89, 255, 116), 0.6);
  opacity: 0.9;
}

.play-button i {
  color: #000;
  font-size: 1rem;
  margin-left: 2px;
}

.card-content-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  background: white;
  padding: 12px 14px;
  margin: 0 -12px -12px -12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  border-radius: 0 0 14px 14px;
}

.card-bg {
  background-image: url("@/assets/images/card-bg.svg");
  background-size: cover;
}

.service-heading {
  margin: 0;
  color: #212529;
  font-size: 0.8rem;
  font-weight: 700;
  background: transparent;
  line-height: 1.25;
  word-break: break-word;
  hyphens: auto;
}

.service-heading.long-text {
  font-size: 0.7rem;
  line-height: 1.2;
}

.read-more-btn {
  background: var(--primary-color);
  border: none;
  border-radius: 10px;
  padding: 6px 10px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #212529;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  cursor: pointer;
  margin-top: auto;
}

.read-more-btn:hover {
  background: var(--primary-color);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
  opacity: 0.9;
}

.read-more-btn i {
  margin-left: 4px;
  font-size: 0.6rem;
}

@media (max-width: 768px) {
  .instant-service-card {
    height: 220px;
  }

  .icon-wrapper {
    width: 60px;
    height: 60px;
  }

  .card-icon {
    font-size: 1.5rem;
  }

  .play-button {
    width: 38px;
    height: 38px;
  }

  .play-button i {
    font-size: 0.85rem;
  }

  .service-heading {
    font-size: 0.8rem;
  }
}

/* Slide up fade animation */
.slide-up-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-up-fade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
